import CustomJsonLd from './CustomJsonLd'
import { getJsonLdDomId, normalizeJsonLdSchemaItems } from '@/lib/jsonLd'

/**
 * Renders all JSON-LD schema blocks for a page.
 * Accepts the raw array from the CMS and normalizes it before rendering.
 *
 * Usage in a Server Component:
 *   <JsonLdBlocks schemas={jsonLdSchemas} />
 */
interface JsonLdBlocksProps {
  schemas?: { jsonld: Record<string, unknown> }[] | null
}

export default function JsonLdBlocks({ schemas = null }: JsonLdBlocksProps) {
  const blocks = normalizeJsonLdSchemaItems(Array.isArray(schemas) ? schemas : [])

  if (!blocks?.length) {
    return null
  }

  return (
    <>
      {blocks.map((schema, index) => {
        const id = getJsonLdDomId(schema.jsonld, index)
        return <CustomJsonLd key={id} id={id} data={schema.jsonld} />
      })}
    </>
  )
}
